import { jsxs as B, jsx as n } from "react/jsx-runtime";
import { DealActionContainer as P, CustomDealActionBar as T } from "./style.js";
import { DealStatus as g, PositionStamp as v } from "../../../types/Deal/index.js";
import { DealActionStampButton as I } from "../DealActionStampButton/index.js";
function $({
  deal: t,
  isCouponRevealed: i,
  voteInfo: r,
  className: m,
  dealClickoutUrl: e,
  dealUrl: a,
  isSaved: c,
  hasSaveButton: s,
  commentIDHash: p,
  copyButtonLabel: u,
  ariaLabelIcon: l,
  iconColor: f,
  goToClickoutUrl: A,
  dispatch: o,
  onClickout: C
}) {
  const { id: D, commentCount: x, temperature: E, status: S } = t, j = S !== g.ACTIVE;
  return /* @__PURE__ */ B(P, { className: m, children: [
    /* @__PURE__ */ n(
      I,
      {
        deal: t,
        isCouponRevealed: i,
        dealClickoutUrl: e,
        dealUrl: a,
        copyButtonLabel: u,
        ariaLabelIcon: l,
        goToClickoutUrl: A,
        dispatch: o,
        position: v.CENTER,
        onClickout: C
      }
    ),
    /* @__PURE__ */ n(
      T,
      {
        id: D,
        inactive: j,
        commentUrl: `#${p}`,
        commentCount: x,
        temperature: E,
        voteInfo: r,
        dispatch: o,
        isSaved: c,
        hasSaveButton: s,
        iconColor: f
      }
    )
  ] });
}
export {
  T as CustomDealActionBar,
  $ as DealPageAction
};
